import React from 'react';
import { MenuItems, type MenuItemsProps } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import { TicketStatus } from 'flow/types/Tickets';

import StatePickerItem from './StatePickerItem';
import { STATUS_KEYS_IN_ORDER } from './state-labels';

interface Props {
    onSelect: (key: TicketStatus) => void;
    // When set, the menu is portaled and positioned against the button via
    // floating-ui, so it can escape an `overflow-hidden` ancestor (e.g. a list
    // row). When omitted, it renders in place, absolutely positioned.
    anchor?: MenuItemsProps['anchor'];
}

const StatePickerMenu = ({ onSelect, anchor }: Props) => (
    <MenuItems
        anchor={anchor}
        className={twMerge(
            'shadow-base z-20 mt-2 w-40 rounded-md bg-white p-2 outline-gray-100 focus:outline dark:bg-gray-300',
            anchor ? null : 'origin-top-end absolute end-0',
        )}
    >
        {STATUS_KEYS_IN_ORDER.map((statusKey) => (
            <StatePickerItem
                key={statusKey}
                statusKey={statusKey}
                onSelect={onSelect}
            />
        ))}
    </MenuItems>
);

export default React.memo(StatePickerMenu);
